import React from "react";
import { SignOutButton } from "./SignOutButton";
import { UserIcon } from "../../../assets/icons/UserIcon";
import "./UserMenu.css";

export const UserMenu = ({ user }) => {
  return (
    <div className="userMenu">
      <div className="userMenuSegment">
        <UserIcon />
        <div>{user?.displayName || `${user?.firstName} ${user?.lastName}`}</div>
        <div className="userMenuEmail">{user.email}</div>
      </div>
      <div className="userMenuSegment">
        <SignOutButton />
      </div>
    </div>
  );
};
